const plainText = (str: string) => {
  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(str, 'text/html');
  const strPlain = htmlDoc.body.textContent;

  return strPlain;
};

export default plainText;
